// Client testimonials. Empty for now — real quote drops in before launch.

export interface Testimonial {
  quote: string;
  author: string;
  role: string;
}

export const TESTIMONIALS: Testimonial[] = [];
